import React from "react";
import { HOTEL } from "@/lib/site";

export function BookButton({ label = "Book Direct & Save", variant = "solid", testid = "book-cta", className = "" }) {
  const base =
    "inline-flex items-center justify-center rounded-full px-8 py-4 text-sm font-medium tracking-wide transition-colors duration-300";
  const styles =
    variant === "solid"
      ? "bg-amber text-bone hover:bg-amber-deep"
      : variant === "forest"
      ? "bg-forest text-bone hover:bg-amber"
      : "border border-current text-current hover:bg-amber hover:text-bone hover:border-amber";
  return (
    <a href={HOTEL.booking} target="_blank" rel="noreferrer" data-testid={testid} className={`${base} ${styles} ${className}`}>
      {label}
    </a>
  );
}

export function SectionHeading({ eyebrow, title, align = "left", light = false, className = "" }) {
  return (
    <div className={`${align === "center" ? "text-center mx-auto" : ""} max-w-3xl ${className}`}>
      {eyebrow && (
        <span className={`text-xs uppercase tracking-[0.25em] ${light ? "text-amber" : "text-amber-deep"}`}>
          {eyebrow}
        </span>
      )}
      <h2
        className={`font-serif text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.05] mt-4 ${
          light ? "text-bone" : "text-forest"
        }`}
      >
        {title}
      </h2>
    </div>
  );
}
